import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { ReactComponent as ErrorIcon } from "../../../../assets/icons/error.svg";
import T from "../../../../components/Typography";
import { colors } from "../../../../styles";
import Button from "../../../../components/Button";
import { employeeTransfersPath } from "../../../../routes/paths";
import { useIsMobile } from "../../../../helpers/ui";
import Loader from "../../../../components/Loader";

const TransferError = () => {
  const [isLoading, setIsLoading] = useState(true);
  const navigate = useNavigate();
  const isMobile = useIsMobile();

  useEffect(() => {
    setTimeout(() => {
      setIsLoading(false);
    }, 1500);
  }, []);

  return (
    <div
      style={{
        height: "100vh",
        width: "100%",
        position: "absolute",
        left: 0,
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
      }}
    >
      <div
        style={{ width: isMobile ? "90%" : "40%", textAlign: "center" }}
        className="flex flex-col items-center"
      >
        {isLoading ? (
          <Loader text="Loading..." />
        ) : (
          <>
            <ErrorIcon />
            <T variant="headingSm" sx={{ marginTop: "16px" }}>
              Unable to Initiate Transfer
            </T>
            <T
              variant="mdReg"
              sx={{ marginTop: "16px" }}
              color={colors.gray_600}
            >
              Please contact our support team in chat and we will help.
            </T>
            <Button onClick={() => navigate(employeeTransfersPath)}>
              Take Me Back to Transfers
            </Button>
          </>
        )}
      </div>
    </div>
  );
};

export default TransferError;
